import { render, staticRenderFns } from "./employeecredential.vue?vue&type=template&id=f2dcfdda&"
import script from "./employeecredential.vue?vue&type=script&lang=js&"
export * from "./employeecredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports